import { render, staticRenderFns } from "./sopWin.vue?vue&type=template&id=59e787f5&scoped=true"
import script from "./sopWin.vue?vue&type=script&lang=js"
export * from "./sopWin.vue?vue&type=script&lang=js"
import style0 from "./sopWin.vue?vue&type=style&index=0&id=59e787f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e787f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e787f5')) {
      api.createRecord('59e787f5', component.options)
    } else {
      api.reload('59e787f5', component.options)
    }
    module.hot.accept("./sopWin.vue?vue&type=template&id=59e787f5&scoped=true", function () {
      api.rerender('59e787f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sopWin.vue"
export default component.exports